//import {IArticleContentPage} from "@montana/models/generated/cms.interface";
import React from "react";
import {Container} from "@montana/shared/container";
import {DynamicBlocks} from "@montana/blocks/dynamic-blocks.component";
import {IBlock} from "@montana/models/generated/cms.interface";

interface IArticleContentPage extends IBlock {
    blocks: IBlock[];
}

export function ArticlePage(props: IArticleContentPage) {

    const { blocks } = props;

    return (
        <Container>
            <DynamicBlocks blocks={blocks} isFirstElementOnPage />
        </Container>
    );
}
